import React from 'react';

function TemplateLayout({ children }) {
  return <div className="templategrid ">{children}</div>;
}
export default TemplateLayout;
